import dayjs from 'dayjs'
import { motion } from 'framer-motion'
import React from 'react'
import {
    STAGE_COLORS,
    cardVariants,
    getStageColor,
    hasValidEndDate,
} from './career-path-constants'
import type { CompletedStageCardProps } from './career-path-types'
import NotesList from './NotesList'
import StageCardActions from './StageCardActions'
import TimelineDot from './TimelineDot'

const CompletedStageCard: React.FC<CompletedStageCardProps> = ({
    path,
    index,
    stageInfo,
    isSelf,
    isExpanded,
    onToggleExpand,
    onEdit,
    onAddNote,
    t,
}) => {
    const stage = path.career_path_stage

    return (
        <motion.div
            className="relative pl-10"
            custom={index}
            variants={cardVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            layout
        >
            <TimelineDot stage={stage} isLast={false} index={index} />

            <motion.div
                className="border border-gray-200 rounded-lg p-4 bg-white transition-shadow"
                whileHover={{
                    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                    borderColor: STAGE_COLORS[stage]?.dot || '#e5e7eb',
                }}
                transition={{ duration: 0.2 }}
            >
                {/* Header */}
                <div className="flex items-center justify-between gap-2">
                    <div className="flex items-center gap-3">
                        <span
                            className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${getStageColor(stage)}`}
                        >
                            {stageInfo?.label || stage}
                        </span>
                        <span className="text-sm text-gray-500">
                            {dayjs(path.career_path_start_date).format(
                                'DD/MM/YYYY'
                            )}
                            {hasValidEndDate(path.career_path_end_date) &&
                                ` → ${dayjs(path.career_path_end_date).format('DD/MM/YYYY')}`}
                        </span>
                    </div>

                    {!isSelf && (
                        <StageCardActions
                            transitionActions={[]}
                            onTransition={() => {}}
                            onEdit={onEdit}
                            t={t}
                        />
                    )}
                </div>

                {/* Note */}
                {path.career_path_note && (
                    <p className="mt-2 text-sm text-gray-600">
                        {path.career_path_note}
                    </p>
                )}

                {/* Collapsible notes */}
                <NotesList
                    notes={path.notes || []}
                    isActive={false}
                    isSelf={isSelf}
                    isExpanded={isExpanded}
                    onToggleExpand={onToggleExpand}
                    onAddNote={onAddNote}
                    t={t}
                />
            </motion.div>
        </motion.div>
    )
}

export default CompletedStageCard
